import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { compliancesClient } from '../../../../utils/apollo/api'
import { getQueryParam } from '../../../../utils/helpers/url'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { convertFilterToRelativeDates } from '../../../../utils/helpers/date'

const Context = React.createContext([])
const { Provider } = Context
export const useNonCompliancesState = () => React.useContext(Context)
export const useNonCompliances = () => useNonCompliancesState()?.nonCompliances

const QUERY = gql`
  query NonCompliances($page: Int, $search: String, $sort: [NonComplianceSort], $filter: NonComplianceFilter) {
    nonCompliances(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      place {
        id
        name
        resume
      }
      question {
        id
        name
        type {
          id
          name
        }
        checklist {
          id
          name
        }
        category {
          id
          name
        }
      }
      actionPlansCount
      finishedActionPlansCount
      instancesCount
      status
      insertedAt
      updatedAt
      endDate
    }
  }
`

const NonCompliancesLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  let filter = useCleanFilterForRequest()
  filter = convertFilterToRelativeDates(filter)

  const origin = getQueryParam('origin') || 'serviceOrder'

  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: [{ field: field || 'UPDATED_AT', type: type || 'DESC' }],
      filter: { origins: origin, ...filter }
    },
    flexiblePollInterval: 30000,
    client: compliancesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default NonCompliancesLoader
